<script>
export default {
  data() {
    return {}
  },
  created: () => {},
  methods: {},
}
</script>

<template>
  <div>
    <slot />
  </div>
</template>
